import { render, staticRenderFns } from "./payment-type-pill.vue?vue&type=template&id=2bb7cd9c&scoped=true&"
import script from "./payment-type-pill.vue?vue&type=script&setup=true&lang=js&"
export * from "./payment-type-pill.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./payment-type-pill.vue?vue&type=style&index=0&id=2bb7cd9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7cd9c",
  null
  
)

export default component.exports